<!-- 月报管理 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="营业厅名称">
              <a-input placeholder="请输入营业厅名称" v-model="queryParam.businessName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div> -->
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="contentInfo" slot-scope="text,record">
          <div class="contentInfo" v-html="text"></div>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from './DailyManagementModal'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';

  export default {
    name: 'list',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal
    },
    data () {
      return {
        url: {
          list: "/jeecg-oa/jobLogging/bsJobLogging/list",
          delete: "/jeecg-oa/jobLogging/bsJobLogging/delete",
          deleteBatch: "/jeecg-oa/jobLogging/bsJobLogging/deleteBatch",
          // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
          // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
        queryParam:{
          jobLoggingType: 2
        }
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('工作日期'),
            align:"center",
            dataIndex: 'workDate',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工作内容'),
            align:"center",
            dataIndex: 'contentInfo',
            scopedSlots: { customRender: 'contentInfo' },
            width: 300,
            ellipsis: true,
          },
          // {
          //   title:'附件',
          //   align:"center",
          //   dataIndex: 'files',
          // },
          {
            title: this.$t('抄送人员'),
            align:"center",
            dataIndex: 'sendUserName',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工作人'),
            align:"center",
            dataIndex: 'createBy',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('提交时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工作开始时间'),
            align:"center",
            dataIndex: 'jobStartTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('工作结束时间'),
            align:"center",
            dataIndex: 'jobEndTime',
            width: 150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      handleAdd(){
        this.$nextTick(()=>{
          this.$refs.modalForm.init({},'add',2);
        });
      },
      handleEdit(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'edit',2);
        });
      },
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row,'detail',2);
        });
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  /deep/.contentInfo{
    p{
      margin: 0;
    }
  }
</style>